import React from "react";

export interface VirtualWalletsData {
  accountName: string;
  accountNumber: string;
  bankName: string;
  bvn: string;
}

export const ColumnVirtualWallets = [
  {
    Header: "Account Name",
    accessor: "accountName",
  },
  {
    Header: "Account Number",
    accessor: "accountNumber",
  },
  {
    Header: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "BVN",
    accessor: "bvn",
  },
];
